/* Raghu  26/10/2022   3075154998   Search Filter Group card fields enhancements */
/* Rohini  28/10/2022   3075154998   text fields enhancements */
import React, {useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import FilterGroupSearchTable from './FilterGroupSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import * as Yup from 'yup';
const SearchFilterGroupContainer = ({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setRecordFormatFilterGroupId,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setIsCopyRowData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const schema = Yup.object().shape({
    code: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });
  const initialValues = {
    code: '',
    displayName: '',
    description: '',
  };
  const onClear = () => {
    const data = {
      code: '',
      displayName: '',
      description: '',
    };
    setSearchData(data);
  };

  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  return (
    <div>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {touched, errors, values, handleChange, handleReset, handleBlur} = props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <ErrorBoundaryForComponents>
                  <Grid className="form-row global-field-textfields" container spacing={2}>
                    <>
                      <Grid item xs={4} xl={3} sm={6} md={3} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter Filter Group Code`}
                          label="Filter Group Code"
                          name="code"
                          value={values?.code?.toUpperCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors.code && errors.code}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4} xl={3} sm={6} md={3} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter Filter Group Name`}
                          label="Filter Group Name"
                          name="displayName"
                          value={values.displayName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={4} xl={3} sm={6} md={3} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter Filter Group Description`}
                          label="Filter Group Description"
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={4} xl={3} sm={6} md={3} className="form-group">
                        <div className="d-flex justify-content-end align-items-center">
                          <Button
                            variant="outlined"
                            className={`reset-btn  mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData({});
                              setSubmit(true);
                              onClear();
                            }}
                          >
                            Clear
                          </Button>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`search-btn mx-1  ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </Grid>
                    </>
                  </Grid>
                </ErrorBoundaryForComponents>
              </Form>
            </div>
          );
        }}
      </Formik>
      <FilterGroupSearchTable
        submit={submit}
        setSubmit={setSubmit}
        setFilterGroupCode={setFilterGroupCode}
        setSelectedFilterGroupCode={setSelectedFilterGroupCode}
        setTabValue={setTabValue}
        searchData={searchData}
        handleClose={handleClose}
        setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
        setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
        setIsCopyRowData={setIsCopyRowData}
      />
    </div>
  );
};

export default SearchFilterGroupContainer;
